<template>
  <v-main id="app2">
    <v-layout fill-height column>
      <v-row no-gutters>
        <v-col
          sm="6"
          cols="12"
          v-show="!swipeDirection"
          v-touch="{
            left: () => swipe('Left'),
            right: () => swipe('Right'),
          }"
        >
          <v-card elevation="0" height="100%">
            <div
              v-touch="{
                left: () => swipe('Left'),
                right: () => swipe('Right'),
              }"
              class="iframetouch"
            ></div>

            <div class="box">
              <iframe
                class="iframe"
                v-if="StudentData.book_name != '프리토킹'"
                :src="StudentData.book_path"
                frameborder="0"
              ></iframe>
              <div
                v-if="StudentData.book_name == '프리토킹'"
                class="font-weight-black marg-ftc"
              >
                This is a Freetalking Class.
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col
          sm="6"
          cols="12"
          v-show="swipeDirection"
          v-touch="{
            left: () => swipe('Left'),
            right: () => swipe('Right'),
          }"
          :class="$vuetify.breakpoint.lgAndUp ? 'd-flex' : ''"
        >
          <v-card width="100%" height="100%" elevation="0" class="px-10 py-10">
            <v-row>
              <v-col>
                <div class="montserrat font-24 font-weight-bold">
                  {{ StudentData.name_en }} Class Evaluation
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-5">
              <v-col>
                <div class="font-14 fw-medium">STUDENT'S INFORMATION</div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-row align="center">
                  <v-col cols="2">
                    <v-img
                      src="../../../assets/images/RegularClass/forms/icons/clock.svg"
                      aspect-ratio="1"
                      max-height="24"
                      contain
                    ></v-img>
                  </v-col>
                  <v-col>
                    <div class="font-14 fw-light">{{ StudentData.time }}</div>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="2">
                    <v-img
                      src="../../../assets/images/RegularClass/forms/icons/calendar.svg"
                      aspect-ratio="1"
                      max-height="24"
                      contain
                    ></v-img>
                  </v-col>
                  <v-col>
                    <div class="font-14 fw-light">
                      {{ StudentData.nOfWeek }}
                    </div>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="2">
                    <v-img
                      src="../../../assets/images/RegularClass/forms/icons/phone.svg"
                      aspect-ratio="1"
                      max-height="24"
                      contain
                    ></v-img>
                  </v-col>
                  <v-col>
                    <div class="font-14 fw-light">
                      {{ StudentData.classType }} Class
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row align="center">
                  <v-col cols="2">
                    <v-img
                      src="../../../assets/images/RegularClass/forms/icons/notebook.svg"
                      aspect-ratio="1"
                      max-height="24"
                      contain
                    ></v-img>
                  </v-col>
                  <v-col>
                    <v-select
                      v-model="attendance"
                      :items="items"
                      item-text="category"
                      item-value="value"
                      single-line
                      :value="absent()"
                      class="font-14 pt-0 mt-0"
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="2">
                    <v-img
                      src="../../../assets/images/RegularClass/forms/icons/level.svg"
                      aspect-ratio="1"
                      max-height="24"
                      contain
                    ></v-img>
                  </v-col>
                  <v-col>
                    <div class="font-14 fw-light">
                      Level {{ StudentData.level_v }}
                    </div>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="2">
                    <v-img
                      src="../../../assets/images/RegularClass/forms/icons/open-book.svg"
                      aspect-ratio="1"
                      max-height="24"
                      contain
                    ></v-img>
                  </v-col>
                  <v-col>
                    <div class="font-14 fw-light">
                      {{
                        StudentData.book_name == "프리토킹"
                          ? "Free Talking"
                          : StudentData.book_name
                      }}
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-stepper v-model="e1" alt-labels flat>
                  <v-stepper-header stepper-width>
                    <v-stepper-step
                      step="1"
                      @click="e1 = 1"
                      class="font-10 fw-normal"
                    >
                      Feedback
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step
                      step="2"
                      @click="e1 = 2"
                      class="font-10 fw-normal"
                    >
                      Tips
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step
                      step="3"
                      @click="e1 = 3"
                      class="font-10 fw-normal"
                    >
                      Memo
                    </v-stepper-step>
                  </v-stepper-header>

                  <v-card flat>
                    <v-stepper-items>
                      <v-form ref="form">
                        <v-stepper-content step="1">
                          <v-flex>
                            <v-row>
                              <v-col>
                                <div class="font-14 fw-medium">
                                  Today’s Lesson
                                </div>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-row align="center">
                                  <v-col sm="3">
                                    <div class="font-14 fw-light">
                                      Topic
                                    </div>
                                  </v-col>
                                  <v-col>
                                    <v-text-field
                                      :placeholder="
                                        this.StudentData.prev_eval.topic
                                          ? this.StudentData.prev_eval.topic
                                          : ''
                                      "
                                      :readonly="
                                        attendance == 'absent' ? true : false
                                      "
                                      class="font-11 fw-light mt-0 pt-0"
                                      :rules="
                                        attendance == 'absent' ? '' : inputRules
                                      "
                                      v-model="topic"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col>
                                <v-row align="center">
                                  <v-col sm="3">
                                    <div class="font-14 fw-light">
                                      Page
                                    </div>
                                  </v-col>
                                  <v-col>
                                    <v-text-field
                                      :placeholder="
                                        this.StudentData.prev_eval.page
                                          ? this.StudentData.prev_eval.page
                                          : ''
                                      "
                                      type="number"
                                      :readonly="
                                        attendance == 'absent' ||
                                        StudentData.book_name == '프리토킹' ||
                                        StudentData.book_name ==
                                          'Kinder Times' ||
                                        StudentData.book_name == 'Kids Times' ||
                                        StudentData.book_name ==
                                          'Junior Times' ||
                                        StudentData.book_name == 'Teen Times'
                                          ? true
                                          : false
                                      "
                                      class="font-11 fw-light mt-0 pt-0"
                                      :rules="
                                        attendance == 'absent' ||
                                        StudentData.book_name == '프리토킹' ||
                                        StudentData.book_name ==
                                          'Kinder Times' ||
                                        StudentData.book_name == 'Kids Times' ||
                                        StudentData.book_name ==
                                          'Junior Times' ||
                                        StudentData.book_name == 'Teen Times'
                                          ? ''
                                          : inputRules
                                      "
                                      v-model="page"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <div class="font-14 fw-medium">
                                  Sentence Correction
                                </div>
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col>
                                <v-card
                                  flat
                                  color="#F5F5F5"
                                  class="px-5 py-5 my-5"
                                >
                                  <v-row no-gutters align="center">
                                    <v-col cols="1" class="mr-5">
                                      <v-img
                                        src="../../../assets/images/RegularClass/speak.svg"
                                        contain
                                      />
                                    </v-col>
                                    <v-col>
                                      <v-text-field
                                        :readonly="
                                          attendance == 'absent' ? true : false
                                        "
                                        class="font-14 fw-light"
                                        :rules="
                                          attendance == 'absent'
                                            ? ''
                                            : inputRules
                                        "
                                        v-model="mdi_close1"
                                        placeholder="Student’s sentence"
                                      >
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row no-gutters align="center">
                                    <v-col cols="1" class="mr-5">
                                      <v-img
                                        src="../../../assets/images/RegularClass/idea.svg"
                                        contain
                                      />
                                    </v-col>
                                    <v-col>
                                      <v-text-field
                                        :readonly="
                                          attendance == 'absent' ? true : false
                                        "
                                        class="font-14 fw-light"
                                        :rules="
                                          attendance == 'absent'
                                            ? ''
                                            : inputRules
                                        "
                                        v-model="mdi_check1"
                                        placeholder="Improved sentence"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col>
                                <v-card
                                  flat
                                  color="#F5F5F5"
                                  class="px-5 py-5 my-5"
                                >
                                  <v-row no-gutters align="center">
                                    <v-col cols="1" class="mr-5">
                                      <v-img
                                        src="../../../assets/images/RegularClass/speak.svg"
                                        contain
                                      />
                                    </v-col>
                                    <v-col>
                                      <v-text-field
                                        :readonly="
                                          attendance == 'absent' ? true : false
                                        "
                                        class="font-14 fw-light"
                                        :rules="
                                          attendance == 'absent'
                                            ? ''
                                            : inputRules
                                        "
                                        v-model="mdi_close2"
                                        placeholder="Student’s sentence"
                                      >
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row no-gutters align="center">
                                    <v-col cols="1" class="mr-5">
                                      <v-img
                                        src="../../../assets/images/RegularClass/idea.svg"
                                        contain
                                      />
                                    </v-col>
                                    <v-col>
                                      <v-text-field
                                        :readonly="
                                          attendance == 'absent' ? true : false
                                        "
                                        class="font-14 fw-light"
                                        :rules="
                                          attendance == 'absent'
                                            ? ''
                                            : inputRules
                                        "
                                        v-model="mdi_check2"
                                        placeholder="Improved sentence"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col>
                                <v-card
                                  flat
                                  color="#F5F5F5"
                                  class="px-5 py-5 my-5"
                                >
                                  <v-row no-gutters align="center">
                                    <v-col cols="1" class="mr-5">
                                      <v-img
                                        src="../../../assets/images/RegularClass/speak.svg"
                                        contain
                                      />
                                    </v-col>
                                    <v-col>
                                      <v-text-field
                                        :readonly="
                                          attendance == 'absent' ? true : false
                                        "
                                        class="font-14 fw-light"
                                        :rules="
                                          attendance == 'absent'
                                            ? ''
                                            : inputRules
                                        "
                                        v-model="mdi_close3"
                                        placeholder="Student’s sentence"
                                      >
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row no-gutters align="center">
                                    <v-col cols="1" class="mr-5">
                                      <v-img
                                        src="../../../assets/images/RegularClass/idea.svg"
                                        contain
                                      />
                                    </v-col>
                                    <v-col>
                                      <v-text-field
                                        :readonly="
                                          attendance == 'absent' ? true : false
                                        "
                                        class="font-14 fw-light"
                                        :rules="
                                          attendance == 'absent'
                                            ? ''
                                            : inputRules
                                        "
                                        v-model="mdi_check3"
                                        placeholder="Improved sentence"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col>
                                <v-card
                                  flat
                                  color="#F5F5F5"
                                  class="px-5 py-5 my-5"
                                >
                                  <v-row no-gutters align="center">
                                    <v-col cols="1" class="mr-5">
                                      <v-img
                                        src="../../../assets/images/RegularClass/speak.svg"
                                        contain
                                      />
                                    </v-col>
                                    <v-col>
                                      <v-text-field
                                        :readonly="
                                          attendance == 'absent' ? true : false
                                        "
                                        class="font-14 fw-light"
                                        :rules="
                                          attendance == 'absent'
                                            ? ''
                                            : inputRules
                                        "
                                        v-model="mdi_close4"
                                        placeholder="Student’s sentence"
                                      >
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row no-gutters align="center">
                                    <v-col cols="1" class="mr-5">
                                      <v-img
                                        src="../../../assets/images/RegularClass/idea.svg"
                                        contain
                                      />
                                    </v-col>
                                    <v-col>
                                      <v-text-field
                                        :readonly="
                                          attendance == 'absent' ? true : false
                                        "
                                        class="font-14 fw-light"
                                        :rules="
                                          attendance == 'absent'
                                            ? ''
                                            : inputRules
                                        "
                                        v-model="mdi_check4"
                                        placeholder="Improved sentence"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <div class="font-14 fw-medium">
                                  Words to be Careful With
                                </div>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-row no-gutters align="center">
                                  <v-col sm="2">
                                    <div class="font-14 fw-light">
                                      1.
                                    </div>
                                  </v-col>
                                  <v-col>
                                    <v-text-field
                                      :readonly="
                                        attendance == 'absent' ? true : false
                                      "
                                      class="font-14 fw-light"
                                      :error-messages="
                                        errorword1 && attendance != 'absent'
                                          ? 'No word found. Please check the spelling.'
                                          : ''
                                      "
                                      :rules="
                                        attendance == 'absent' ? '' : inputRules
                                      "
                                      v-model="word1"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col>
                                <v-row no-gutters align="center">
                                  <v-col sm="2">
                                    <div class="font-14 fw-light">
                                      2.
                                    </div>
                                  </v-col>
                                  <v-col>
                                    <v-text-field
                                      :readonly="
                                        attendance == 'absent' ? true : false
                                      "
                                      class="font-14 fw-light"
                                      :rules="
                                        attendance == 'absent' ? '' : inputRules
                                      "
                                      v-model="word2"
                                      :error-messages="
                                        errorword2 && attendance != 'absent'
                                          ? 'No word found. Please check the spelling.'
                                          : ''
                                      "
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col>
                                <v-row no-gutters align="center">
                                  <v-col sm="2">
                                    <div class="font-14 fw-light">
                                      3.
                                    </div>
                                  </v-col>
                                  <v-col>
                                    <v-text-field
                                      :readonly="
                                        attendance == 'absent' ? true : false
                                      "
                                      class="font-14 fw-light"
                                      :rules="
                                        attendance == 'absent' ? '' : inputRules
                                      "
                                      v-model="word3"
                                      :error-messages="
                                        errorword3 && attendance != 'absent'
                                          ? 'No word found. Please check the spelling.'
                                          : ''
                                      "
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col class="d-flex justify-center">
                                <v-btn
                                  color="#02A9F4"
                                  class="ma-2 white--text font-18"
                                  @click="(e1 = 2), scrollTop()"
                                  elevation="0"
                                  large
                                  style="text-transform: none !important"
                                >
                                  Next
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-flex>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                          <v-flex>
                            <v-row>
                              <v-col>
                                <div class="font-14 fw-medium">
                                  Choose the appropriate tip for your student
                                </div>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-expansion-panels flat>
                                  <v-expansion-panel>
                                    <v-expansion-panel-header
                                      class="font-14 fw-light"
                                    >
                                      Vowels
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                      <v-radio-group
                                        v-model="vowelnun"
                                        required
                                      >
                                        <v-card
                                          color="#D9F3FF"
                                          elevation="0"
                                          class="px-5 py-5"
                                        >
                                          <v-row>
                                            <v-col>
                                              <v-radio
                                                v-for="pro in vowels"
                                                :key="pro.title"
                                                :label="pro.title"
                                                :value="pro.value"
                                                v-on:click="scorevow()"
                                                class="font-14 fw-light"
                                              >
                                              </v-radio>
                                            </v-col>
                                            <v-col>
                                              <v-radio
                                                v-for="pro in vowels2"
                                                :key="pro.title"
                                                :label="pro.title"
                                                :value="pro.value"
                                                v-on:click="scorevow()"
                                                class="font-14 fw-light"
                                              ></v-radio>
                                            </v-col>
                                          </v-row>
                                        </v-card>
                                      </v-radio-group>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                  <v-expansion-panel>
                                    <v-expansion-panel-header
                                      class="font-14 fw-light"
                                    >
                                      Consonants
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                      <v-radio-group v-model="cons" required>
                                        <v-card
                                          color="#D9F3FF"
                                          elevation="0"
                                          class="px-5 py-5"
                                        >
                                          <v-row>
                                            <v-col>
                                              <v-radio
                                                v-for="cons in consonants"
                                                :key="cons.title"
                                                :label="cons.title"
                                                :value="cons.value"
                                                v-on:click="scorecons()"
                                              ></v-radio>
                                            </v-col>
                                            <v-col>
                                              <v-radio
                                                v-for="cons in consonants2"
                                                :key="cons.title"
                                                :label="cons.title"
                                                :value="cons.value"
                                                v-on:click="scorecons()"
                                              ></v-radio>
                                            </v-col>
                                          </v-row>
                                        </v-card>
                                      </v-radio-group>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                </v-expansion-panels>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col class="d-flex justify-end">
                                <v-btn
                                  color="#02A9F4"
                                  class="ma-2 font-18"
                                  @click="(e1 = 1), scrollTop()"
                                  elevation="0"
                                  large
                                  style="text-transform: none !important"
                                  outlined
                                  width="50%"
                                >
                                  Previous
                                </v-btn>
                              </v-col>
                              <v-col class="d-flex justify-start">
                                <v-btn
                                  color="#02A9F4"
                                  class="ma-2 white--text font-18"
                                  @click="(e1 = 3), scrollTop()"
                                  elevation="0"
                                  large
                                  style="text-transform: none !important"
                                  width="50%"
                                >
                                  Next
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-flex>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                          <v-flex>
                            <v-row>
                              <v-col>
                                <div class="font-14 fw-medium">
                                  Memo
                                </div>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  rows="3"
                                  auto-grow
                                  :rules="inputRules"
                                  class="font-14 fw-light"
                                  v-model="memo"
                                  placeholder="Please write about any issues encountered in the class or special requests of the student here."
                                  :error-messages="
                                    errormemo && attendance == 'absent'
                                      ? 'Item is Required'
                                      : ''
                                  "
                                ></v-textarea>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col class="d-flex justify-center">
                                <v-btn
                                  color="#02A9F4"
                                  class="ma-2 font-18"
                                  @click="(e1 = 2), scrollTop()"
                                  elevation="0"
                                  large
                                  style="text-transform: none !important"
                                  outlined
                                  width="80%"
                                >
                                  Previous
                                </v-btn>
                              </v-col>
                              <v-col class="d-flex justify-center">
                                <v-btn
                                  @click="openDialog()"
                                  color="#02A9F4"
                                  class="ma-2 font-18"
                                  elevation="0"
                                  large
                                  style="text-transform: none !important; background-color: #DEF5FF"
                                  outlined
                                  width="80%"
                                >
                                  Preview
                                </v-btn>
                              </v-col>
                              <v-col class="d-flex justify-center">
                                <v-btn
                                  color="#02A9F4"
                                  class="ma-2 white--text font-18"
                                  @click="submit()"
                                  elevation="0"
                                  large
                                  style="text-transform: none !important"
                                  width="80%"
                                >
                                  Submit
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-flex>
                         
                            
                                
<!-- 
                                <div
                                  class="text-h3"
                                  v-show="attendance == 'absent' ? true : false"
                                >
                                  Data Successfully Saved!
                                </div>
                              </v-card-text>
                              <v-card-actions class="justify-end">
                                <v-btn
                                  text
                                  @click="(dialogshow = false), pauseAudioPro()"
                                >
                                  <span class="white--text"> Close </span>
                                </v-btn>
                              </v-card-actions> -->
                            

                        </v-stepper-content>
                      </v-form>
                    </v-stepper-items>
                  </v-card>
                </v-stepper>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <!-- <v-flex
        lg6
        xs12
        v-show="!swipeDirection"
        v-touch="{
          left: () => swipe('Left'),
          right: () => swipe('Right'),
        }"
      >
        <v-card class="elevation-0 scroll-left "> -->
      <!-- <LevelTest /> -->

      <!-- <div
            v-touch="{
              left: () => swipe('Left'),
              right: () => swipe('Right'),
            }"
            class="iframetouch"
          ></div> -->

      <!-- <span class="text-lg-h4 text-h6 "> IFRAME FOR MATERIAL </span> -->
      <!-- <div class="box">
            <iframe
              class="iframe"
              v-if="StudentData.book_name != '프리토킹'"
              :src="StudentData.book_path"
              frameborder="0"
            ></iframe>
            <div
              v-if="StudentData.book_name == '프리토킹'"
              class="font-weight-black marg-ftc"
            >
              This is a Freetalking Class.
            </div>
          </div> -->

      <!-- <v-subheader>Swipe Direction</v-subheader>
    {{ swipeDirection }} -->
      <!-- </v-card>
      </v-flex> -->

      <!-- <v-flex lg6 xs12 px-lg-10 px-5 mt-lg-n1 mt-5 d-none d-lg-flex v-show="!swipeDirection"> -->
      <!-- <v-flex
        lg6
        xs12
        px-lg-10
        px-5
        mt-lg-n1
        mt-5
        d-lg-flex
        v-show="swipeDirection"
        v-touch="{
          left: () => swipe('Left'),
          right: () => swipe('Right'),
        }"
        class="box-right scroll-left scrollUp"
      >
        <div class="mt-5 scroll-right">
          <p>
            <span class="font-weight-medium text-lg-h6 text-h5 montserrat">
              {{ StudentData.name_en }} Class Evaluation
            </span>
            <br />
          </p>

          <p>
            <span class="font-weight-medium font12 font14 montserrat">
              STUDENT'S INFORMATION
            </span>
          </p>

          <v-layout row class="mt-6 ml-1">
            <v-flex lg6 md2 xs12>
              <v-layout>
                <v-flex lg1 md3 xs1>
                  <p>
                    <v-img
                      src="../../../assets/images/RegularClass/forms/icons/clock.svg"
                      aspect-ratio="1"
                      max-height="15"
                      contain
                    ></v-img>
                  </p>
                  <p>
                    <v-img
                      src="../../../assets/images/RegularClass/forms/icons/calendar.svg"
                      aspect-ratio="1"
                      max-height="15"
                      contain
                    ></v-img>
                  </p>
                  <p>
                    <v-img
                      src="../../../assets/images/RegularClass/forms/icons/phone.svg"
                      aspect-ratio="1"
                      max-height="15"
                      contain
                    ></v-img>
                  </p>
                </v-flex> -->
      <!-- <v-flex lg5 md3 xs12> -->
      <!-- {{StudentData}} -->
      <!-- <v-list class="mt-n6 ml-lg-5 mt-lg-n6 ml-5">
                    <v-list-item-content
                      class="font-weight-medium montserrat font12 font14"
                    >
                      {{ StudentData.time }}
                    </v-list-item-content>
                    <v-list-item-content
                      class="font-weight-medium mt-n2 montserrat font12 font14"
                    >
                      {{ StudentData.nOfWeek }}
                    </v-list-item-content>
                    <v-list-item-content
                      class="font-weight-medium mt-n3 montserrat font12 font14"
                    >
                      {{ StudentData.classType }} Class
                    </v-list-item-content>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex lg6 md2 xs12>
              <v-layout>
                <v-flex lg1 md3 xs1>
                  <p>
                    <v-img
                      src="../../../assets/images/RegularClass/forms/icons/notebook.svg"
                      aspect-ratio="1"
                      max-height="15"
                      contain
                    ></v-img>
                  </p>
                  <p>
                    <v-img
                      src="../../../assets/images/RegularClass/forms/icons/level.svg"
                      aspect-ratio="1"
                      max-height="15"
                      contain
                    ></v-img>
                  </p>
                  <p>
                    <v-img
                      src="../../../assets/images/RegularClass/forms/icons/open-book.svg"
                      aspect-ratio="1"
                      max-height="15"
                      contain
                    ></v-img>
                  </p>
                </v-flex>

                <v-flex lg8 md3 xs12 class="ml-lg-5 ml-5 mt-n7 montserrat ">
                  <template id="selectAttendance">
                    <v-select
                      v-model="attendance"
                      :items="items"
                      item-text="category"
                      item-value="value"
                      single-line
                      :value="absent()"
                      class="font12 font14"
                    ></v-select>
                  </template>
                  <br />
                  <div class="mt-lg-n9 mt-n9 montserrat font12 font14">
                    Level {{ StudentData.level_v }}
                  </div>
                  <br />
                  <div class="mt-lg-n3 mt-n4 montserrat font12 font14">
                    {{
                      StudentData.book_name == "프리토킹"
                        ? "Free Talking"
                        : StudentData.book_name
                    }}
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-flex>
            <v-stepper
              v-model="e1"
              alt-labels
              class="elevation-0 mt-lg-5 mt-n4"
            >
              <v-flex xs8 class="ml-lg-0 ml-2 montserrat">
                <v-stepper-header
                  class=" ml-lg-8 ml-n16 mt-lg-0 mt-12 elevation-0 stepper-width"
                >
                  <v-stepper-step :complete="e1 > 1" step="1" @click="e1 = 1">
                    <small> Feedback </small>
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :complete="e1 > 2" step="2" @click="e1 = 2">
                    <small> Tips </small>
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step
                    step="3"
                    @click="(e1 = 3), (listgroup = true)"
                  >
                    <small> Memo </small>
                  </v-stepper-step>
                </v-stepper-header>
              </v-flex>

              <v-stepper-items
                class="ml-lg-n6 mt-lg-0 ml-n8 stepper-item-width montserrat"
              >
                <v-form ref="form">
                  <v-stepper-content step="1">
                    <v-layout row>
                      <v-flex lg11 md2 xs10 class="mt-2 ml-lg-3 ml-3">
                        <p
                          class="text-lg-body-1 text-h6 montserrat ml-lg-1 ml-2 mt-lg-0 mt-2"
                        >
                          Today’s Lesson
                        </p>
                        <v-layout row>
                          <v-flex lg6 xs10 md6>
                            <v-row align="center" class="ml-lg-3 ml-5">
                              Topic
                              <v-text-field
                                :placeholder="
                                  this.StudentData.prev_eval.topic
                                    ? this.StudentData.prev_eval.topic
                                    : ''
                                "
                                :readonly="
                                  attendance == 'absent' ? true : false
                                "
                                class="font12 font14 ml-2"
                                :rules="
                                  attendance == 'absent' ? '' : inputRules
                                "
                                v-model="topic"
                              >
                              </v-text-field>
                              <br />
                            </v-row>
                          </v-flex>
                          <v-flex lg6 xs10 md6>
                            <v-row align="center" class="ml-lg-5 ml-5">
                              Page
                              <v-text-field
                                :placeholder="
                                  this.StudentData.prev_eval.page
                                    ? this.StudentData.prev_eval.page
                                    : ''
                                "
                                type="number"
                                :readonly="
                                  attendance == 'absent' ||
                                  StudentData.book_name == '프리토킹' ||
                                    StudentData.book_name == 'Kinder Times' ||
                                    StudentData.book_name == 'Kids Times' ||
                                    StudentData.book_name == 'Junior Times' ||
                                    StudentData.book_name == 'Teen Times'
                                    ? true
                                    : false
                                "
                                class="ml-2 font12 font14"
                                :rules="
                                  attendance == 'absent' ||
                                  StudentData.book_name == '프리토킹' ||
                                  StudentData.book_name == 'Kinder Times' ||
                                  StudentData.book_name == 'Kids Times' ||
                                  StudentData.book_name == 'Junior Times' ||
                                  StudentData.book_name == 'Teen Times'
                                    ? ''
                                    : inputRules
                                "
                                v-model="page"
                              >
                              </v-text-field>
                              <br />
                            </v-row>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>

                    <v-flex lg12 md2 xs12 class=" mt-10 px-lg-0 px-3">
                      <p class="text-lg-body-1 text-h6 montserrat">
                        Sentence Correction
                      </p>
                    </v-flex>

                    <v-flex
                      lg12
                      md12
                      xs12
                      class="mt-n4 px-lg-1 px-0 ml-0 ml-lg-0"
                    >
                      <v-list>
                        <v-card
                          color="rgb(245, 245, 245)"
                          class="px-lg-2 pr-lg-10 elevation-0 rounded-lg mt-lg-5 mt-5 px-7"
                        >
                          <v-row align="center" class="ml-lg-0 pr-16 pr-lg-0">
                            <v-img
                              src="../../../assets/images/RegularClass/speak.svg"
                              max-height="30"
                              max-width="30"
                              contain
                            />
                            <v-text-field
                              :readonly="attendance == 'absent' ? true : false"
                              class="ml-2 font12 font14"
                              :rules="attendance == 'absent' ? '' : inputRules"
                              v-model="mdi_close1"
                              placeholder="Student’s sentence"
                            >
                            </v-text-field>
                            <br />
                          </v-row>

                          <v-row
                            align="center"
                            class="mt-lg-n4 mt-n4 ml-lg-1 pr-16 pr-lg-0"
                          >
                            <v-img
                              src="../../../assets/images/RegularClass/idea.svg"
                              max-height="30"
                              max-width="30"
                              contain
                            />
                            <v-text-field
                              :readonly="attendance == 'absent' ? true : false"
                              class="ml-2 font12 font14"
                              :rules="attendance == 'absent' ? '' : inputRules"
                              v-model="mdi_check1"
                              placeholder="Improved sentence"
                            ></v-text-field>
                          </v-row>
                        </v-card>

                        <v-card
                          color="rgb(245, 245, 245)"
                          class="px-lg-2 pr-lg-10 elevation-0 rounded-lg mt-lg-5 mt-5 px-7"
                        >
                          <v-row align="center" class="ml-lg-0 pr-16 pr-lg-0">
                            <v-img
                              src="../../../assets/images/RegularClass/speak.svg"
                              max-height="30"
                              max-width="30"
                              contain
                            />
                            <v-text-field
                              :readonly="attendance == 'absent' ? true : false"
                              class="ml-2 font12 font14"
                              :rules="attendance == 'absent' ? '' : inputRules"
                              v-model="mdi_close2"
                              placeholder="Student’s sentence"
                            >
                            </v-text-field>
                            <br />
                          </v-row>

                          <v-row
                            align="center"
                            class="mt-lg-n4 mt-n4 ml-lg-1 pr-16 pr-lg-0"
                          >
                            <v-img
                              src="../../../assets/images/RegularClass/idea.svg"
                              max-height="30"
                              max-width="30"
                              contain
                            />
                            <v-text-field
                              :readonly="attendance == 'absent' ? true : false"
                              class="ml-2 font12 font14"
                              :rules="attendance == 'absent' ? '' : inputRules"
                              v-model="mdi_check2"
                              placeholder="Improved sentence"
                            ></v-text-field>
                          </v-row>
                        </v-card>

                        <v-card
                          color="rgb(245, 245, 245)"
                          class="px-lg-2 pr-lg-10 elevation-0 rounded-lg mt-lg-5 mt-5 px-7"
                        >
                          <v-row align="center" class="ml-lg-0 pr-16 pr-lg-0">
                            <v-img
                              src="../../../assets/images/RegularClass/speak.svg"
                              max-height="30"
                              max-width="30"
                              contain
                            />
                            <v-text-field
                              :readonly="attendance == 'absent' ? true : false"
                              class="ml-2 font12 font14"
                              :rules="attendance == 'absent' ? '' : inputRules"
                              v-model="mdi_close3"
                              placeholder="Student’s sentence"
                            >
                            </v-text-field>
                            <br />
                          </v-row>

                          <v-row
                            align="center"
                            class="mt-lg-n4 mt-n4 ml-lg-1 pr-16 pr-lg-0"
                          >
                            <v-img
                              src="../../../assets/images/RegularClass/idea.svg"
                              max-height="30"
                              max-width="30"
                              contain
                            />
                            <v-text-field
                              :readonly="attendance == 'absent' ? true : false"
                              class="ml-2 font12 font14"
                              :rules="attendance == 'absent' ? '' : inputRules"
                              v-model="mdi_check3"
                              placeholder="Improved sentence"
                            ></v-text-field>
                          </v-row>
                        </v-card>

                        <v-card
                          color="rgb(245, 245, 245)"
                          class="px-lg-2 pr-lg-10 elevation-0 rounded-lg mt-lg-5 mt-5 px-7"
                        >
                          <v-row align="center" class="ml-lg-0 pr-16 pr-lg-0">
                            <v-img
                              src="../../../assets/images/RegularClass/speak.svg"
                              max-height="30"
                              max-width="30"
                              contain
                            />
                            <v-text-field
                              :readonly="attendance == 'absent' ? true : false"
                              class="ml-2 font12 font14"
                              :rules="attendance == 'absent' ? '' : inputRules"
                              v-model="mdi_close4"
                              placeholder="Student’s sentence"
                            >
                            </v-text-field>
                            <br />
                          </v-row>

                          <v-row
                            align="center"
                            class="mt-lg-n4 mt-n4 ml-lg-1 pr-16 pr-lg-0"
                          >
                            <v-img
                              src="../../../assets/images/RegularClass/idea.svg"
                              max-height="30"
                              max-width="30"
                              contain
                            />
                            <v-text-field
                              :readonly="attendance == 'absent' ? true : false"
                              class="ml-2 font12 font14"
                              :rules="attendance == 'absent' ? '' : inputRules"
                              v-model="mdi_check4"
                              placeholder="Improved sentence"
                            ></v-text-field>
                          </v-row>
                        </v-card>
                      </v-list>

                      <v-flex xs10 class="px-2 px-lg-2 mt-5 ml-lg-0 ml-n2 px-6">
                        <p class="text-lg-body-1 text-h6 montserrat">
                          Words to be Careful With
                        </p>
                      </v-flex>

                      <v-layout row>
                        <v-flex lg5 xs10 class="px-lg-0 ml-lg-3 mt-lg-4 px-10">
                          <v-row align="center" class="ml-lg-3">
                            1.
                            <v-text-field
                              :readonly="attendance == 'absent' ? true : false"
                              class="ml-lg-1 mt-lg-n2 ml-2 font12 font14"
                              :error-messages="
                                errorword1 && attendance != 'absent'
                                  ? 'No word found. Please check the spelling.'
                                  : ''
                              "
                              :rules="attendance == 'absent' ? '' : inputRules"
                              v-model="word1"
                            >
                            </v-text-field>
                            <br />
                          </v-row>
                        </v-flex>

                        <v-flex lg5 xs10 class="px-lg-2 mt-lg-5 px-10 ml-lg-12">
                          <v-row align="center">
                            2.
                            <v-text-field
                              :readonly="attendance == 'absent' ? true : false"
                              class="ml-lg-1 mt-lg-n3 ml-2 font12 font14"
                              :rules="attendance == 'absent' ? '' : inputRules"
                              v-model="word2"
                              :error-messages="
                                errorword2 && attendance != 'absent'
                                  ? 'No word found. Please check the spelling.'
                                  : ''
                              "
                            >
                            </v-text-field>
                          </v-row>
                        </v-flex>
                        <v-flex lg5 xs10 class="px-lg-0 ml-lg-3 mt-lg-4 px-10">
                          <v-row align="center" class="ml-lg-3">
                            3.
                            <v-text-field
                              :readonly="attendance == 'absent' ? true : false"
                              class="ml-lg-1 mt-lg-n2 ml-2 font12 font14"
                              :error-messages="
                                errorword3 && attendance != 'absent'
                                  ? 'No word found. Please check the spelling.'
                                  : ''
                              "
                              :rules="attendance == 'absent' ? '' : inputRules"
                              v-model="word3"
                            >
                            </v-text-field>
                            <br />
                          </v-row>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex
                      lg12
                      md2
                      xs12
                      class="mt-lg-12 pb-lg-6 mt-12 ml-lg-0 ml-n5 pb-lg-0 pb-6 "
                    >
                      <div>
                        <v-layout justify-center>
                          <v-btn
                            class="ma-2 btn-color"
                            @click="(e1 = 2), scrollTop()"
                          >
                            NEXT
                          </v-btn>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-stepper-content>

                  <v-stepper-content step="2" id="stepper2-height">
                    <v-flex lg12 md2 xs11 class="mt-0 px-lg-0 px-2">
                      <p class="text-lg-body-1 text-h6 montserrat">
                        Choose the appropriate tip for your student
                      </p>
                    </v-flex>
                    <v-flex
                      lg12
                      md2
                      xs11
                      class="mt-n4 px-lg-0 px-2 ml-n2 ml-lg-0 montserrat"
                    > -->
      <!-- dropdowns -->

      <!-- <v-list v-show="attendance == 'absent' ? false : true">
                        <v-list-group
                          :value="listgroup1"
                          style="border-bottom:1px solid black !important; "
                        >
                          <template v-slot:activator>
                            <v-list-item-content>
                              <v-list-item-title class="font12 font14">
                                Vowels
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>
                          <v-flex lg12 xs12 class="montserrat">
                            <v-radio-group v-model="vowelnun" required>
                              <v-card
                                class="px-lg-5 py-lg-10 px-8 py-10 elevation-0 rad-btn-bg rounded-xl radio-font"
                              >
                                <v-layout row>
                                  <v-flex lg6 xs12>
                                    <v-radio
                                      v-for="pro in vowels"
                                      :key="pro.title"
                                      :label="pro.title"
                                      :value="pro.value"
                                      v-on:click="scorevow()"
                                      class="font12 font14"
                                    >
                                    </v-radio>
                                  </v-flex>

                                  <v-flex lg6 xs12>
                                    <v-radio
                                      v-for="pro in vowels2"
                                      :key="pro.title"
                                      :label="pro.title"
                                      :value="pro.value"
                                      v-on:click="scorevow()"
                                    >
                                    </v-radio>
                                  </v-flex>
                                </v-layout>
                              </v-card>
                            </v-radio-group>
                          </v-flex>
                        </v-list-group>

                        <v-list-group
                          :value="listgroup2"
                          style="border-bottom:1px solid black !important; "
                        >
                          <template v-slot:activator>
                            <v-list-item-content>
                              <v-list-item-title class="font12 font14">
                                Consonants
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>
                          <v-flex lg12 xs12>
                            <v-radio-group v-model="cons" required>
                              <v-card
                                class="px-lg-5 py-lg-10 px-8 py-10 elevation-0 rad-btn-bg rounded-xl"
                              >
                                <v-layout row>
                                  <v-flex lg6 xs12 class="montserrat">
                                    <v-radio
                                      v-for="cons in consonants"
                                      :key="cons.title"
                                      :label="cons.title"
                                      :value="cons.value"
                                      v-on:click="scorecons()"
                                    >
                                    </v-radio>
                                  </v-flex>

                                  <v-flex lg6 xs12>
                                    <v-radio
                                      v-for="cons in consonants2"
                                      :key="cons.title"
                                      :label="cons.title"
                                      :value="cons.value"
                                      v-on:click="scorecons()"
                                    >
                                    </v-radio>
                                  </v-flex>
                                </v-layout>
                              </v-card>
                            </v-radio-group>
                          </v-flex>
                        </v-list-group>
                      </v-list>
                      <span class="red--text">
                        {{ errorTips ? errorTips : "" }}
                      </span>
                    </v-flex>
                    <v-flex
                      lg12
                      md2
                      xs12
                      class="mt-lg-12 pb-lg-6 mt-12 ml-lg-0 ml-n7 pb-10"
                    >
                      <div>
                        <v-layout justify-center>
                          <v-btn
                            class="ma-2"
                            outlined
                            color="primary"
                            @click="(e1 = 1), scrollTop()"
                          >
                            Previous
                          </v-btn>
                          <v-btn
                            class="ma-2 btn-color"
                            @click="(e1 = 3), scrollTop()"
                          >
                            NEXT
                          </v-btn>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-stepper-content>

                  <v-stepper-content step="3" class=" ml-lg-0">
                    <v-flex lg12 md2 xs11 class="mt-0 px-lg-0 px-2">
                      <p class="text-lg-body-1 text-h6 montserrat">Memo</p>
                    </v-flex>

                    <v-flex lg12 md2 xs11 class="mt-n4 px-lg-0 px-2 montserrat">
                      <v-text-field
                        :rules="inputRules"
                        class="font12 font14"
                        v-model="memo"
                        placeholder="Please write about any issues encountered in the class or special requests of the student here."
                        :error-messages="
                          errormemo && attendance == 'absent'
                            ? 'Item is Required'
                            : ''
                        "
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex
                      lg12
                      md2
                      xs12
                      class="mt-lg-12 pb-lg-6 mt-12 ml-lg-0 ml-n7 text-center pb-10"
                    >
                      <div>
                        <v-layout justify-center row>
                          <v-flex lg3 xs12 class="ml-lg-12">
                            <v-btn
                              class="ma-2"
                              outlined
                              color="primary"
                              @click="(e1 = 2), scrollTop()"
                            >
                              Previous
                            </v-btn>
                          </v-flex>

                          <v-flex lg3 xs12 class="ml-lg-n6">
                            <v-btn
                              color="primary"
                              outlined
                              @click="openDialog()"
                              class="mt-2"
                              style="background-color:#D9F3FF"
                              >Preview</v-btn
                            >
                          </v-flex>

                          <v-flex lg3 xs12 class="ml-lg-n8">
                            <v-btn class="ma-2 btn-color" @click="submit()">
                              Submit
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>

                    <v-dialog
                      transition="dialog-bottom-transition"
                      max-width="100%"
                      v-model="dialogshow"
                      persistent
                    >
                      <v-card style="background-color:#000C17 !important">
                        <v-card-actions class="justify-end">
                          <v-btn
                            text
                            @click="(dialogshow = false), pauseAudioPro()"
                          >
                            <span class="white--text"> Close </span>
                          </v-btn>
                        </v-card-actions>
                        <v-card-text>
                          <StudentEvaluation
                            v-show="attendance == 'absent' ? false : true"
                            :stud-name="StudentData.name_en"
                            :topic-discuss="topic"
                            :page-num="page"
                            :submit-stat="submit"
                            :wrong-one="mdi_close1"
                            :wrong-two="mdi_close2"
                            :wrong-three="mdi_close3"
                            :wrong-four="mdi_close4"
                            :correct-one="mdi_check1"
                            :correct-two="mdi_check2"
                            :correct-three="mdi_check3"
                            :correct-four="mdi_check4"
                            :word-one="word1"
                            :word-two="word2"
                            :word-three="word3"
                            :tip-score="tipScore"
                            :comment-text="comment"
                          />

                          <div
                            class="text-h3"
                            v-show="attendance == 'absent' ? true : false"
                          >
                            Data Successfully Saved!
                          </div>
                        </v-card-text>
                        <v-card-actions class="justify-end">
                          <v-btn
                            text
                            @click="(dialogshow = false), pauseAudioPro()"
                          >
                            <span class="white--text"> Close </span>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-stepper-content>
                </v-form>
              </v-stepper-items>
            </v-stepper>
          </v-flex>
        </div>

        <div></div>
      </v-flex> -->
    </v-layout>
    <StudentEvaluation ref="studentEvalDialog"/>
  </v-main>
</template>
<script>
// import LevelTest from '../leveltest/leveltest.vue'
import StudentEvaluation from "../evaluations/StudentEvaluation.vue";
import Vue from "vue";
import axios from "axios";
Vue.use(axios);
export default {
  name: "Form",
  components: {
    // LevelTest,
    StudentEvaluation,
  },
  data: () => {
    return {
      dialogshow: false,
      swipeDirection: false,
      attendance: "atten",
      topic: "",
      page: "",
      submitStat: "",
      items: [
        { category: "Present", value: "atten" },
        { category: "Absent", value: "absent" },
      ],

      AllCategory: 0,
      vowels: [
        {
          title: "/i/ very, pleased, meet",
          value: 1,
        },
        {
          title: "/eɪ/ making, cake, birthday ",
          value: 3,
        },
        { title: "/æ/ family, travel, California", value: 5 },
        { title: "/ə/ apartment, beautiful, colorful", value: 7 },
        { title: "/oʊ/ okay, show, photos ", value: 9 },
        { title: "/u/ June, too, humid", value: 11 },
        { title: "/aɪ/ advise, ride, bicycle", value: 13 },
        { title: "/ɔɪ/ enjoys, coins", value: 15 },
      ],
      vowels2: [
        { title: "/ɪ/ visit, sister, sit, kitchen", value: 2 },
        { title: "/ɛ/ next, step, recipe", value: 4 },
        { title: "/ɑ/ forgot, lock, car", value: 6 },
        { title: "/ɔ/ always, abroad, autumn", value: 8 },
        { title: "/ʊ/ good, books ", value: 10 },
        { title: "/ər/ smarter, sister, harder", value: 12 },
        { title: "/aʊ/ found, couch lounge", value: 14 },
      ],
      consonants: [
        {
          title: "/f/ fault, leaf",
          value: 16,
        },
        {
          title: "/v/ vault,leave",
          value: 17,
        },
        {
          title: "/θ/ thank, breath",
          value: 18,
        },
        {
          title: "/ð/ this,breathe",
          value: 19,
        },
        {
          title: "/s/ sink, price",
          value: 20,
        },
        {
          title: "/z/ zinc, prize",
          value: 21,
        },
        {
          title: "/ʃ/ pressure, wish",
          value: 22,
        },
        {
          title: "/ʒ/ pleasure, massage",
          value: 23,
        },
      ],
      consonants2: [
        {
          title: "/tʃ/ choke, rich",
          value: 24,
        },
        {
          title: "/ʤ/ joke,ridge",
          value: 25,
        },
        {
          title: "/ŋ/ going, spring, king",
          value: 26,
        },
        {
          title: "/l/ love, will, yellow",
          value: 27,
        },
        {
          title: "/r/ red, four, card",
          value: 28,
        },
        {
          title: "/w/ win, lower, quiet",
          value: 29,
        },
        {
          title: "/y/ yes, mayor,young",
          value: 30,
        },
        {
          title: "/h/ happy, behave, who",
          value: 31,
        },
      ],
      tipScore: "",
      tipText: "",
      errorTips: false,
      vowelVal: 0,
      vowelnun: 0,
      consVal: 0,
      cons: 0,
      level: 0,
      levelNumber: 0,
      listgroup1: false,
      listgroup2: false,
      listgroup1error: false,
      listgroup2error: false,
      word1: "",
      errorword1: false,
      errorword2: false,
      errorword3: false,
      errormemo: false,
      errorWordcount1: 0,
      errorWordcount2: 0,
      errorWordcount3: 0,
      word2: "",
      word3: "",
      comment: "",
      memo: "",
      totalscores: 0,
      errorpro: "",
      mdi_close1: "",
      mdi_check1: "",
      mdi_check2: "",
      mdi_close2: "",
      mdi_close3: "",
      mdi_check3: "",
      mdi_close4: "",
      mdi_check4: "",
      e1: 1,
      audioVal1: "",
      audioVal2: "",
      audioVal3: "",
      inputRules: [(v) => v.length >= 1 || "Item is Required"],
      radioRules: [(v) => !!v || "Item is Required! Please Select One Answer"],
      fetchmsgOnly: "",
      StudentData: "",
      getResult: false,
      StudentInfo: "",
      tutor_id:"",
    };
  },

  computed: {
    posts() {
      return {
        action:
          this.$route.params.actionrc == "edit" ? "editEval" : "insertEval",
        s_id: this.$route.params.s_id,
        todate: this.$route.params.todate,
        attendance: this.attendance != "" ? this.attendance : "absent",
        feedBack: {
          correction: [
            {
              wrong: this.mdi_close1 != "" ? this.mdi_close1 : "empty",
              correct: this.mdi_check1 != "" ? this.mdi_check1 : "empty",
            },
            {
              wrong: this.mdi_close2 != "" ? this.mdi_close2 : "empty",
              correct: this.mdi_check2 != "" ? this.mdi_check2 : "empty",
            },
            {
              wrong: this.mdi_close3 != "" ? this.mdi_close3 : "empty",
              correct: this.mdi_check3 != "" ? this.mdi_check3 : "empty",
            },
            {
              wrong: this.mdi_close4 != "" ? this.mdi_close4 : "empty",
              correct: this.mdi_check4 != "" ? this.mdi_check4 : "empty",
            },
          ],
          word: [
            this.word1 != "" ? this.word1 : "empty",
            this.word2 != "" ? this.word2 : "empty",
            this.word3 != "" ? this.word3 : "empty",
          ],
        },

        pronunciation_tip: {
          text: this.attendance != "absent" ? this.tipText : "empty",
          value: this.tipScore != "" ? this.tipScore : "0",
        },
        memo: this.memo,
        lesson: {
          topic: this.attendance != "absent" ? this.topic : "empty",
          pagec: this.attendance != "absent" ? this.page : "empty",
        },
      };
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollListener);

    // get tutorID
    axios
      .get(
        "https://phone.megatalking.com/origin/api/regularclass_evaluation.php?s_id=" +
          this.$route.params.s_id + 
            "&action=studentInfo"
      )
      //.then(response=>console.warn(response.data))
      .then((response) => (this.tutor_id = response.data
      ));


    axios
      .get(
        "https://phone.megatalking.com/origin/api/regularclass_evaluation.php?s_id=" +
          this.$route.params.s_id + "&user_id="+this.tutor_id.teacher_id +
            "&user_type=teacher&action=studentInfo"
      )
      //.then(response=>console.warn(response.data))
      .then((response) => (this.StudentData = response.data
      ));
    // console.log(this.$route.params.actionrc)
    if (this.$route.params.actionrc == "edit") {
      this.editStatusInfo();
    }
  },
  watch: {},
  methods: {
    pauseAudioPro() {
      Vue.prototype.$audiopro.pause();
      Vue.prototype.$audiopro.currentTime = 0;
    },
    scrollTop() {
      var el = document.querySelector(".scrollUp");
      el.scrollTop = 0;
    },
    async editStatusInfo() {
      await axios
        .get(
          "https://phone.megatalking.com/origin/api/regularclass_evaluation.php?s_id=" +
            this.$route.params.s_id +
            "&todate=" +
            this.$route.params.todate + "&user_id="+this.tutor_id.teacher_id+
            "&user_type=teacher&action=classResult"
        )
        // .then(response=>console.warn(response.data))
        .then((response) => (this.StudentInfo = response.data.contents));

      await this.attendance;
      await this.mdi_close1;
      await this.mdi_close2;
      await this.mdi_close3;
      await this.mdi_check1;
      await this.mdi_check2;
      await this.mdi_check3;
      await this.word1;
      await this.word2;
      await this.memo;
      await this.vowelnun;
      await this.cons;
      await this.tipScore;
      await this.topic;
      await this.page;

      this.attendance = this.StudentInfo.attendance;

      this.memo = this.StudentInfo.memo;

      this.vowelnun = this.StudentInfo.pronunciation_tip.value;
      this.cons = this.StudentInfo.pronunciation_tip.value;
      this.tipText = this.StudentInfo.pronunciation_tip.text;
      this.tipScore = this.StudentInfo.pronunciation_tip.value;
      this.topic = this.StudentInfo.lesson.topic;
      this.page = this.StudentInfo.lesson.pagec;

      let arr = this.StudentInfo.feedBack.correction;

      this.word1 = this.StudentInfo.feedBack.word[0];
      this.word2 = this.StudentInfo.feedBack.word[1];

      if (typeof this.StudentInfo.feedBack.word[2] !== "undefined") {
        this.word3 = this.StudentInfo.feedBack.word[2];
      }

      for (let x = 0; x <= arr.length; x++) {
        this["mdi_close" + (x + 1)] = arr[x].wrong;
        this["mdi_check" + (x + 1)] = arr[x].correct;
      }
    },

    absent() {
      if (this.attendance == "absent") {
        this.e1 = 3;
      }
    },
    async scorevow() {
      await this.tipText;
      await this.tipScore;
      this.AllCategory -= this.vowelVal;
      this.AllCategory += this.vowelnun;
      this.cons = 0;
      this.tipScore = this.vowelnun;

      for (let i = 0; i < this.vowels.length; i++) {
        if (this.vowels[i].value === this.tipScore) {
          this.tipText = this.vowels[i].title;
        }
      }

      for (let i = 0; i < this.vowels2.length; i++) {
        if (this.vowels2[i].value === this.tipScore) {
          this.tipText = this.vowels2[i].title;
        }
      }

      // this.vowelVal = this.vowelnun;
    },
    async scorecons() {
      await this.tipText;
      await this.tipScore;
      this.AllCategory -= this.consVal;
      this.AllCategory += this.cons;
      this.vowelnun = 0;
      this.tipScore = this.cons;
      // this.consVal = this.cons;

      for (let i = 0; i < this.consonants.length; i++) {
        if (this.consonants[i].value === this.tipScore) {
          this.tipText = this.consonants[i].title;
        }
      }

      for (let i = 0; i < this.consonants2.length; i++) {
        if (this.consonants2[i].value === this.tipScore) {
          this.tipText = this.consonants2[i].title;
        }
      }

      // console.log(this.tipText)
    },
    totalScore() {
      return (this.totalscores = this.AllCategory * 10);
    },
    levelResult: function() {
      var totalScore = this.AllCategory * 10;
      if (totalScore <= 50) {
        this.levelNumber = 1;
        return (this.level = "Low Beginner");
      } else if (totalScore >= 51 && totalScore <= 100) {
        this.levelNumber = 2;
        return (this.level = "Beginner");
      } else if (totalScore >= 101 && totalScore <= 150) {
        this.levelNumber = 3;
        return (this.level = "High Beginner");
      } else if (totalScore >= 151 && totalScore <= 200) {
        this.levelNumber = 4;
        return (this.level = "Low Intermediate");
      } else if (totalScore >= 201 && totalScore <= 250) {
        this.levelNumber = 5;
        return (this.level = "Intermediate");
      } else if (totalScore >= 251 && totalScore <= 300) {
        this.levelNumber = 6;
        return (this.level = "High Intermediate");
      } else if (totalScore >= 301 && totalScore <= 350) {
        this.levelNumber = 7;
        return (this.level = "Pre Advanced");
      } else if (totalScore >= 351 && totalScore <= 400) {
        this.levelNumber = 8;
        return (this.level = "Advanced");
      } else if (totalScore >= 401 && totalScore <= 450) {
        this.levelNumber = 9;
        return (this.level = "Post Advanced");
      } else {
        return (this.level = " Undefined Level");
      }
    },
    onClickOne() {
      this.activeone = false;
    },
    onClickTwo() {
      this.activetwo = true;
    },
    submittest() {
      if (this.attendance == "absent") {
        if (this.memo) {
          //   axios.post('http://phone.megatalking.com/origin/api/regularclass_evaluation.php',this.posts)
          //     .then((result)=>{
          //      console.log(result)
          //      }).catch(error=>console.log('this is the error '+error))
          let evalData = []
            evalData.push({
             studName:this.StudentData.name_en,
             topicDiscuss:this.topic,
             pageNum:this.page,
             submitStat:"save",
             wrongOne:this.mdi_close1,
             wrongTwo:this.mdi_close2,
             wrongThree:this.mdi_close3,
             wrongFour:this.mdi_close4,
             correctOne:this.mdi_check1,
             correctTwo:this.mdi_check2,
             correctThree:this.mdi_check3,
             correctFour:this.mdi_check4,
             wordOne:this.word1,
             wordTwo:this.word2,
             wordThree:this.word3,
             tipScore:this.tipScore,
             commentText:this.comment,
             attendance:this.attendance
            })
            this.$refs.studentEvalDialog.open(evalData)
        } else {
          this.errormemo = true;
        }
      } else {
        // axios.post('http://phone.megatalking.com/origin/api/regularclass_evaluation.php',this.posts)
        // .then((result)=>{
        //          console.log(result)
        // }).catch(error=>console.log('this is the error '+error))
        // return this.dialogshow=true
      }
    },
    async submit() {
      await this.submitStat;
      if (this.attendance == "absent") {
        if (this.memo) {
          axios
            .post(
              "https://phone.megatalking.com/origin/api/regularclass_evaluation.php",
              this.posts
            )
            .then((result) => {
              if (result) {
                let evalData = []
              evalData.push({
             studName:this.StudentData.name_en,
             topicDiscuss:this.topic,
             pageNum:this.page,
             submitStat:"save",
             wrongOne:this.mdi_close1,
             wrongTwo:this.mdi_close2,
             wrongThree:this.mdi_close3,
             wrongFour:this.mdi_close4,
             correctOne:this.mdi_check1,
             correctTwo:this.mdi_check2,
             correctThree:this.mdi_check3,
             correctFour:this.mdi_check4,
             wordOne:this.word1,
             wordTwo:this.word2,
             wordThree:this.word3,
             tipScore:this.tipScore,
             commentText:this.comment,
             attendance:this.attendance
            })
            this.$refs.studentEvalDialog.open(evalData)
              }
            })
            .catch((error) => console.log("this is the error " + error));
          let evalData = []
            evalData.push({
             studName:this.StudentData.name_en,
             topicDiscuss:this.topic,
             pageNum:this.page,
             submitStat:"save",
             wrongOne:this.mdi_close1,
             wrongTwo:this.mdi_close2,
             wrongThree:this.mdi_close3,
             wrongFour:this.mdi_close4,
             correctOne:this.mdi_check1,
             correctTwo:this.mdi_check2,
             correctThree:this.mdi_check3,
             correctFour:this.mdi_check4,
             wordOne:this.word1,
             wordTwo:this.word2,
             wordThree:this.word3,
             tipScore:this.tipScore,
             commentText:this.comment,
             attendance:this.attendance
            })
            this.$refs.studentEvalDialog.open(evalData)
        } else {
          this.errormemo = true;
        }
      } else if (this.$refs.form.validate() && this.tipScore > 0) {
        this.errorword1 = false;
        this.errorword2 = false;
        this.errorword3 = false;

        await axios
          .get(
            "https://api.dictionaryapi.dev/api/v2/entries/en_US/" + this.word1
          )
          .then(
            (response) => (this.audioVal1 = response.data[0].phonetics[0].audio)
          )
         .catch(
              (error) =>
                error ? this.getDefinition(this.word3,"audioVal1","errorword3") : ''
            );
        await axios
          .get(
            "https://api.dictionaryapi.dev/api/v2/entries/en_US/" + this.word2
          )
          .then(
            (response) => (this.audioVal2 = response.data[0].phonetics[0].audio)
          )
          .catch(
              (error) =>
                error ? this.getDefinition(this.word3,"audioVal1","errorword3") : ''
            );
        await axios
          .get(
            "https://api.dictionaryapi.dev/api/v2/entries/en_US/" + this.word3
          )
          .then(
            (response) => (this.audioVal3 = response.data[0].phonetics[0].audio)
          )
         .catch(
              (error) =>
                error ? this.getDefinition(this.word3,"audioVal1","errorword3") : ''
            );

        if (
          this.errorword1 == false &&
          this.errorword2 == false &&
          this.errorword3 == false
        ) {
          axios
            .post(
              "https://phone.megatalking.com/origin/api/regularclass_evaluation.php",
              this.posts
            )
            .then((result) => {
              if (result) {
                let evalData = []
            evalData.push({
             studName:this.StudentData.name_en,
             topicDiscuss:this.topic,
             pageNum:this.page,
             submitStat:"save",
             wrongOne:this.mdi_close1,
             wrongTwo:this.mdi_close2,
             wrongThree:this.mdi_close3,
             wrongFour:this.mdi_close4,
             correctOne:this.mdi_check1,
             correctTwo:this.mdi_check2,
             correctThree:this.mdi_check3,
             correctFour:this.mdi_check4,
             wordOne:this.word1,
             wordTwo:this.word2,
             wordThree:this.word3,
             tipScore:this.tipScore,
             commentText:this.comment,
             attendance:this.attendance
            })
            this.$refs.studentEvalDialog.open(evalData)
              }
            })
            .catch((error) => console.log("this is the error " + error));
        }
      } else {
        if (this.mdi_close1 == "") {
          return (this.e1 = 1);
        }
        if (this.mdi_check1 == "") {
          return (this.e1 = 1);
        }
        if (this.mdi_close2 == "") {
          return (this.e1 = 1);
        }
        if (this.mdi_check2 == "") {
          return (this.e1 = 1);
        }
        if (this.mdi_close3 == "") {
          return (this.e1 = 1);
        }
        if (this.mdi_check3 == "") {
          return (this.e1 = 1);
        }
        if (this.mdi_close4 == "") {
          return (this.e1 = 1);
        }
        if (this.mdi_check4 == "") {
          return (this.e1 = 1);
        }
        if (this.word1 == "") {
          return (this.e1 = 1);
        }
        if (this.word2 == "") {
          return (this.e1 = 1);
        }
        if (this.word3 == "") {
          return (this.e1 = 1);
        }
        if (this.tipScore == 0) {
          return (
            (this.e1 = 2),
            (this.errorTips = "Please Select One Value For Each Group")
          );
        }
      }
    },


    openDialogtest() {
      let evalData = []
            evalData.push({
             studName:this.StudentData.name_en,
             topicDiscuss:this.topic,
             pageNum:this.page,
             submitStat:"save",
             wrongOne:this.mdi_close1,
             wrongTwo:this.mdi_close2,
             wrongThree:this.mdi_close3,
             wrongFour:this.mdi_close4,
             correctOne:this.mdi_check1,
             correctTwo:this.mdi_check2,
             correctThree:this.mdi_check3,
             correctFour:this.mdi_check4,
             wordOne:this.word1,
             wordTwo:this.word2,
             wordThree:this.word3,
             tipScore:this.tipScore,
             commentText:this.comment,
             attendance:this.attendance
            })
      this.$refs.studentEvalDialog.open(evalData)
    },
    getDefinition(word,variable,errorword){
          axios
            .get(
              "https://api.dictionaryapi.dev/api/v2/entries/en_US/" + word
            )
            .then(
              (response) =>{
                  
                  this[variable] =  response.data[0].meanings[0].definitions[0].definition
                 
                  
                
              }).catch(
              (error) =>
                error ? (this[errorword] = true) : (this[errorword] = false),
              (this.e1 = 1)
            );
    },
    async openDialog() {
      if (this.attendance != "absent") {
        if (this.$refs.form.validate() && this.tipScore > 0) {
          this.errorword1 = false;
          this.errorword2 = false;
          this.errorword3 = false;

          await axios
            .get(
              "https://api.dictionaryapi.dev/api/v2/entries/en_US/" + this.word1
            )
            .then(
              (response) =>{
                  
                  this.audioVal1 =  response.data[0].phonetics[0].audio 

                   if(!this.audioVal1){
                      this.audioVal1 = response.data[0].phonetics[1].audio
                   }
                
              }).catch(
              (error) =>
                error ? this.getDefinition(this.word1,"audioVal1","errorword1") : ''
            );
          await axios
            .get(
              "https://api.dictionaryapi.dev/api/v2/entries/en_US/" + this.word2
            )
            .then(
              (response) =>
                {this.audioVal2 = response.data[0].phonetics[0].audio
                
                   if(!this.audioVal2){
                      this.audioVal2 = response.data[0].phonetics[1].audio
                  }
                
                }
            )
            .catch(
              (error) =>
                error ? this.getDefinition(this.word2,"audioVal1","errorword2") : ''
            );
          await axios
            .get(
              "https://api.dictionaryapi.dev/api/v2/entries/en_US/" + this.word3
            )
            .then(
              (response) =>
                {this.audioVal3 = response.data[0].phonetics[0].audio
                
                   if(!this.audioVal3){
                      this.audioVal3 = response.data[0].phonetics[1].audio
                  }
                  
                }
            )
            .catch(
              (error) =>
                error ? this.getDefinition(this.word3,"audioVal1","errorword3") : ''
            );

          

          if (
            this.errorword1 == false &&
            this.errorword2 == false &&
            this.errorword3 == false
          ) {
            // this.submitStat = "save";
            // return (this.dialogshow = true);
            let evalData = []
            evalData.push({
             studName:this.StudentData.name_en,
             topicDiscuss:this.topic,
             pageNum:this.page,
             submitStat:"save",
             wrongOne:this.mdi_close1,
             wrongTwo:this.mdi_close2,
             wrongThree:this.mdi_close3,
             wrongFour:this.mdi_close4,
             correctOne:this.mdi_check1,
             correctTwo:this.mdi_check2,
             correctThree:this.mdi_check3,
             correctFour:this.mdi_check4,
             wordOne:this.word1,
             wordTwo:this.word2,
             wordThree:this.word3,
             tipScore:this.tipScore,
             commentText:this.comment,
             attendance:this.attendance
            })
            this.$refs.studentEvalDialog.open(evalData)
          }
        } else {
          if (this.mdi_close1 == "") {
            return (this.e1 = 1);
          }
          if (this.mdi_check1 == "") {
            return (this.e1 = 1);
          }
          if (this.mdi_close2 == "") {
            return (this.e1 = 1);
          }
          if (this.mdi_check2 == "") {
            return (this.e1 = 1);
          }
          if (this.mdi_close3 == "") {
            return (this.e1 = 1);
          }
          if (this.mdi_check3 == "") {
            return (this.e1 = 1);
          }
          if (this.mdi_close4 == "") {
            return (this.e1 = 1);
          }
          if (this.mdi_check4 == "") {
            return (this.e1 = 1);
          }
          if (this.word1 == "") {
            return (this.e1 = 1);
          }
          if (this.word2 == "") {
            return (this.e1 = 1);
          }
          if (this.word3 == "") {
            return (this.e1 = 1);
          }
          if (this.tipScore == 0) {
            return (
              (this.e1 = 2),
              (this.errorTips = "Please Select One Value For Each Group")
            );
          }
        }
      }
    },
    swipe(direction) {
      if (direction == "Left") {
        this.swipeDirection = true;
      } else if (direction == "Right") {
        this.swipeDirection = false;
      }
    },
  },
};
</script>
<style scoped>
@import url("../../../assets/css/RegularClass/style.css");
</style>
<style scoped>
.montserrat {
  font-family: Montserrat !important;
}
html {
  font-family: "Montserrat", serif !important;
  overflow-y: hidden !important;
}
</style>
